import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Slct from "../Slct";
import Button from "../Button";
import ModalCustom from "./modal-template-default";

const ModalConfirm = props => {
  const {
    show,
    closeModal,
    title,
    text,
    confirm,
    options,
    colorScheme,
    maxHeightScroll,
    disableClick = false,
    confirmText,
    select,
    disableClose,
    loading,
    customYesNo,
    ...other
  } = props;

  const [confirmInput, setconfirmInput] = useState();
  useEffect(() => {
    setconfirmInput("");
  }, [show]);

  return (
    <ModalCustom size="md" show={show} onHide={closeModal} disableClose={disableClose} {...other}>
      <ModalCustom.Header>
        <ModalCustom.Title>{title}</ModalCustom.Title>
      </ModalCustom.Header>
      <ModalCustom.Body>
        <Row style={{ maxHeight: maxHeightScroll || "auto", overflow: maxHeightScroll && "auto" }}>
          <Col>
            <div>{text}</div>
            {!!confirmText && (
              <>
                <p className="small-label mt-2">Insira "{confirmText}", sem as aspas, para confirmar sua ação.</p>
                <input
                  autoFocus
                  value={confirmInput}
                  onChange={ev => {
                    setconfirmInput(ev.target.value);
                  }}
                />
              </>
            )}
          </Col>
        </Row>
      </ModalCustom.Body>
      <ModalCustom.Footer>
        <div className="w-100 d-flex justify-content-between">
          <div>
            {!!select?.options?.length && (
              <Slct
                options={select?.options || []}
                value={select?.value}
                placeholder="..."
                onChange={ev => {
                  select.setvalue(ev.value);
                }}
              />
            )}
          </div>
          <div>
            {!options ? (
              <>
                <Button color={`${colorScheme}_ghost`} onClick={closeModal} loading={loading} disabled={disableClose}>
                  {customYesNo?.[1] || "Não"}
                </Button>
                <Button
                  color={colorScheme}
                  onClick={() => {
                    if (!disableClick && !loading && !!show) confirm();
                  }}
                  loading={loading}
                  disabled={confirmText ? confirmText?.toUpperCase() !== confirmInput?.toUpperCase() : false}
                >
                  {customYesNo?.[0] || "Sim"}
                </Button>
              </>
            ) : (
              <>
                {options.map(
                  (__ev, __ev_i) =>
                    __ev.label && (
                      <Button
                        color={__ev.buttonColor}
                        onClick={() => {
                          if (!disableClick && !loading && !!show) __ev.effect();
                        }}
                        loading={loading}
                        disabled={disableClose || confirmText ? confirmText !== confirmInput : false}
                        key={__ev_i}
                      >
                        {__ev.label}
                      </Button>
                    ),
                )}
              </>
            )}
          </div>
        </div>
      </ModalCustom.Footer>
    </ModalCustom>
  );
};

export default ModalConfirm;
